import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import CaseStudies from "../views/CaseStudies.vue";
import WorkWithUs from "../views/WorkWithUs.vue";
// import GetPremium from "../views/GetPremium.vue";
import NotFound from "../views/NotFound.vue";
import V2 from "../views/V2.vue";
import IntelDesk from "../views/IntelDesk.vue";

var meta = {
  home: {
    title: "The Blockchain Analytics Layer | Bubblemaps",
    description:
      "Visual on chain analytics platform for crypto research, tracing funds, and wallet analysis in real-time across all chains",
  },
  casestudies: {
    title: "Case Studies | Bubblemaps",
    description: "Crypto investigations where Bubblemaps made a difference.",
  },
  workwithus: {
    title: "Work with Us | Bubblemaps",
    description: "The Most Advanced Data Visualisation Suite.",
  },
  // getpremium: {
  //   title: "Bubblemaps | Get premium to access our unique crypto bubbles",
  //   description:
  //     "Unlimited access, comprehensive features, infinite possibilities.",
  // },
  v2: {
    title: "Bubblemaps | V2",
    description:
      "Track real-time token distribution, uncover wallet clusters, and explore token history across chains - visually and instantly.",
  },
  inteldesk: {
    title: "Bubblemaps | Intel Desk",
    description:
      "The InfoFi platform for crowdsourced investigations, where findings are ranked by impact and mindshare. Powered by $BMT.",
  },
  notfound: {
    title: "Bubblemaps | 404",
    description: "Page not found.",
  },
};

for (var page in meta) {
  meta[page].metaTags = [
    {
      property: "og:title",
      content: meta[page].title,
    },
    {
      property: "twitter:title",
      content: meta[page].title,
    },
    {
      name: "description",
      content: meta[page].description,
    },
    {
      property: "og:description",
      content: meta[page].description,
    },
    {
      property: "twitter:description",
      content: meta[page].description,
    },
  ];
}

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: meta.home,
  },
  {
    path: "/case-studies",
    name: "Case Studies",
    component: CaseStudies,
    meta: meta.casestudies,
  },
  {
    path: "/work-with-us",
    name: "Work With Us",
    component: WorkWithUs,
    meta: meta.workwithus,
  },
  // {
  //   path: "/get-premium",
  //   name: "Get Premium",
  //   component: GetPremium,
  //   meta: meta.getpremium,
  // },
  {
    path: "/v2",
    name: "V2",
    component: V2,
    meta: meta.v2,
  },
  {
    path: "/intel-desk",
    name: "Intel Desk",
    component: IntelDesk,
    meta: meta.inteldesk,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Not Found",
    component: NotFound,
    meta: meta.notfound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

router.beforeEach((to) => {
  document.title = to.meta.title;
  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
    (el) => el.parentNode.removeChild(el)
  );

  // Turn the meta tag definitions into actual elements in the head.
  to.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");
      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });
      // We use this to track which meta tags we create so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");
      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));
});

export default router;
